import { setDisableProceed } from "../../redux/budgetSlice/budgetSlice";
import RevenueIcon from '../../assets/icons/revenue-icon.svg';
import RupeesIcon from '../../assets/icons/rupee.svg';
import NetCashFlow from '../../assets/icons/coins-hand-icon.svg';

{
        /*Project Summary Table*/
}

{
        /*Tabs Data*/
}
export const tabData = [
        // {
        //         label: 'Revenue',
        //         key: '0',
        // },
        {
                label: 'Project Cost (Direct Material)',
                value: 'other_projects_project_cost_direct_material',
                key: '1',
        },
        {
                label: 'Project Cost (Conversion)',
                value: 'other_projects_project_cost_conversion_cost',
                key: '2',
        },
        {
                label: 'Other Apportioned Cost',
                value: 'other_projects_other_apportioned_cost',
                key: '3',
        },
        {
                label: 'Other Operational Income',
                value: 'other_projects_other_operational_income',
                key: '4',
        },
        // {
        //         label: 'Profit/Loss',
        //         value: 'other_projects_project_cost_direct_material',
        //         key: '5',
        // },
        {
                label: 'Gross Billing',
                value: 'other_projects_gross_billing',
                key: '6',
        },
        {
                label: 'Net Billing',
                value: 'other_projects_net_billing',
                key: '7',
        },
        {
                label: 'Cash Inflow',
                value: 'other_projects_cash_inflow',
                key: '8',
        },
        {
                label: 'Cash Outflow',
                value: 'other_projects_cash_outflow',
                key: '9',
        },
];

export const tabDataFinalPreview = [
        {
                label: 'Revenue',
                value: 'other_projects_revenue',
                key: '0',
        },
        {
                label: 'Project Cost (Direct Material)',
                value: 'other_projects_project_cost_direct_material',
                key: '1',
        },
        {
                label: 'Project Cost (Conversion)',
                value: 'other_projects_project_cost_conversion_cost',
                key: '2',
        },
        {
                label: 'Other Apportioned Cost',
                value: 'other_projects_other_apportioned_cost',
                key: '3',
        },
        {
                label: 'Other Operational Income',
                value: 'other_projects_other_operational_income',
                key: '4',
        },
        {
                label: 'Profit/Loss',
                value: 'other_projects_project_profit_loss',
                key: '5',
        },
        {
                label: 'Gross Billing',
                value: 'other_projects_gross_billing',
                key: '6',
        },
        {
                label: 'Net Billing',
                value: 'other_projects_net_billing',
                key: '7',
        },
        {
                label: 'Cash Inflow',
                value: 'other_projects_cash_inflow',
                key: '8',
        },
        {
                label: 'Cash Outflow',
                value: 'other_projects_cash_outflow',
                key: '9',
        },
];
export const tabDataFinalPreview_versioned = [
  {
    label: 'Revenue',
    value: 'other_projects_revenue_versioned',
    key: '0',
  },
  {
    label: 'Project Cost (Direct Material)',
    value: 'other_projects_project_cost_direct_material_versioned',
    key: '1',
  },
  {
    label: 'Project Cost (Conversion)',
    value: 'other_projects_project_cost_conversion_cost_versioned',
    key: '2',
  },
  {
    label: 'Other Apportioned Cost',
    value: 'other_projects_other_apportioned_cost_versioned',
    key: '3',
  },
  {
    label: 'Other Operational Income',
    value: 'other_projects_other_operational_income_versioned',
    key: '4',
  },
  {
    label: 'Profit/Loss',
    value: 'other_projects_project_profit_loss_versioned',
    key: '5',
  },
  {
    label: 'Gross Billing',
    value: 'other_projects_gross_billing_versioned',
    key: '6',
  },
  {
    label: 'Net Billing',
    value: 'other_projects_net_billing_versioned',
    key: '7',
  },
  {
    label: 'Cash Inflow',
    value: 'other_projects_cash_inflow_versioned',
    key: '8',
  },
  {
    label: 'Cash Outflow',
    value: 'other_projects_cash_outflow_versioned',
    key: '9',
  },
];

{
        /*Data for project table sectors */
}

export const projectCostData = [
        {
                key: '1',
                sector: 'MS Power Sector',
                initialEstimate: '--',
                revisedtecc: '--',
                ccl: '--',
                balance: '--',
        },
        {
                key: '2',
                sector: 'Industry Sector',
                initialEstimate: '--',
                revisedtecc: '--',
                ccl: '--',
                balance: '--',
        },
];

export const projectCostColumns = [
        {
                title: 'Sector',
                dataIndex: 'sector',
                key: 'sector',
                render: (text) => <a href="#">{text}</a>,
        },
        {
                title: 'Initial Estimate',
                dataIndex: 'initialEstimate',
                key: 'initialEstimate',
        },
        {
                title: 'Revised TECC',
                dataIndex: 'revisedtecc',
                key: 'revisedtecc',
        },
        {
                title: 'CCL Upto 31-03-24',
                dataIndex: 'ccl',
                key: 'ccl',
        },
        {
                title: 'Balance Cost as on 01-04-24',
                dataIndex: 'balance',
                key: 'balance',
        },
];

{
        /*Data for revenue table year wise */
}

export const projectRevenueYearlyData = [
        {
                key: '0',
                head: 'Total Revenue',
                boldHeading: true,
        },
        {
                key: '1',
                head: 'MS Power Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
        {
                key: '2',
                head: 'Industry Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
];

{
        /*Data for apportioned cost */
}

export const apportionedCostData = [
        {
                key: '1',
                sector: 'MS Power Sector',
                initialEstimate: '--',
                cci: '--',
                balanceCost: '--',
        },
        {
                key: '2',
                sector: 'Industry Sector',
                initialEstimate: '--',
                cci: '--',
                balanceCost: '--',
        },
];

export const apportionedCostColumns = [
        {
                title: 'Sector',
                dataIndex: 'sector',
                key: 'sector',
                render: (text) => <a href="#">{text}</a>,
        },
        {
                title: 'Initial Estimate',
                dataIndex: 'initialEstimate',
                key: 'initialEstimate',
        },
        {
                title: 'CCI Upto 31-03-24',
                dataIndex: 'cci',
                key: 'cci',
        },
        {
                title: 'Balance cost as on 01-04-24',
                dataIndex: 'balanceCost',
                key: 'balanceCost',
        },
];

{
        /*Data for apportioned cost yearly table*/
}

export const apportionedCostYearlyData = [
        {
                key: '0',
                sector: 'Total Cost',
                boldHeading: true,
        },
        {
                key: '1',
                sector: 'MS Power Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
        {
                key: '2',
                sector: 'Industry Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
];
{
        /*Data for billing  yearly */
}

export const billingYearlyTable = [
        {
                key: '0',
                head: 'Gross Billing',
                boldHeading: true,
        },
        {
                key: '1',
                head: 'MS Power Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
        {
                key: '2',
                head: 'Industry Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
];

{
        /*Data for cash flow yearly*/
}

export const cashFlowYearlyData = [
        {
                key: '0',
                sector: 'Cash Net Flow',
                boldHeading: true,
        },
        {
                key: '1',
                sector: 'MS Power Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
        {
                key: '2',
                sector: 'Industry Sector',
                boldHeading: true,
                render: (text) => (
                        <a
                                href="#"
                                className="text-[#466CE9] underline cursor-pointer font-semibold"
                        >
                                {text}
                        </a>
                ),
        },
];

{
        /*Data for Allocation Summary table on step 1 */
}

export const transformData = ({ data, dispatch }) => {
        const seenHeadTypes = new Set();
        const transformedData = [];
        let shouldDisableProceed = false;
        dispatch(setDisableProceed(false));

        for (const item of data) {
                const { DESC, ADD_PACKAGE_STATUS, HEAD_TYPE, CODE, ...rest } = item;
                const newItem = { HEAD_TYPE, ...rest };

                const headKey = HEAD_TYPE || CODE;

                // Check if there's any CODE with ADD_PACKAGE_STATUS === 1
                // if (CODE && ADD_PACKAGE_STATUS === 1) {
                //         shouldDisableProceed = true;
                // }

                if (!seenHeadTypes.has(headKey)) {
                        seenHeadTypes.add(headKey);
                        if (HEAD_TYPE && ADD_PACKAGE_STATUS === 0) {
                                transformedData.push(item);
                        } else {
                                transformedData.push({
                                        DESC,
                                        ADD_PACKAGE_STATUS,
                                        HEAD_TYPE,
                                        CODE,
                                });
                        }
                        delete newItem.ADD_PACKAGE_STATUS;
                        delete newItem.DESC;
                        if (HEAD_TYPE && ADD_PACKAGE_STATUS === 1) {
                                transformedData.push(newItem);
                        }
                } else {
                        delete newItem.ADD_PACKAGE_STATUS;
                        delete newItem.DESC;
                        transformedData.push(newItem);
                }
        }

        if (shouldDisableProceed && typeof dispatch === 'function') {
                dispatch(setDisableProceed(true));
        }

        return transformedData;
};

export const transformDataCashflow = ({ data, dispatch }) => {
        const seenHeadTypes = new Set();
        const transformedData = [];

        for (const item of data) {
                const { DESC, ADD_PACKAGE_STATUS, HEAD_TYPE, CODE, ...rest } = item;
                const newItem = { ...rest };

                const headKey = HEAD_TYPE || CODE;

                if (!seenHeadTypes.has(headKey)) {
                        seenHeadTypes.add(headKey);
                        if (HEAD_TYPE && ADD_PACKAGE_STATUS === 0) {
                                transformedData.push(item);
                        } else {
                                transformedData.push({
                                        DESC,
                                        ADD_PACKAGE_STATUS,
                                        HEAD_TYPE,
                                        CODE,
                                });
                        }
                        delete newItem.ADD_PACKAGE_STATUS;
                        delete newItem.DESC;
                        if (HEAD_TYPE && ADD_PACKAGE_STATUS === 1) {
                                transformedData.push(newItem);
                        }
                } else {
                        delete newItem.ADD_PACKAGE_STATUS;
                        delete newItem.DESC;
                        transformedData.push(newItem);
                }
        }

        return transformedData;
};

export const generateMonthExecution = (
        startMonthNumber,
        startYear,
        startMonth = 1,
        totalMonths = 24,
) => {
        const months = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
        ];
        let monthExecution = {};
        let monthCounter = startMonthNumber;
        let monthIndex = startMonth - 1; // Convert to zero-based index
        let currentYear = startYear;

        for (let i = 0; i < totalMonths; i++) {
                let formattedYear = String(currentYear).slice(-2); // Extract last two digits of the year
                let currentMonth = months[monthIndex % 12]; // Wrap around after December

                let monthKey = `${currentMonth}_${formattedYear}`; // Format MMM'YY
                monthExecution[monthKey] = `M${monthCounter}`;

                monthCounter++;
                monthIndex++;

                // Check if we crossed December -> Move to next financial year
                if (monthIndex % 12 === 0) {
                        currentYear++;
                }
        }

        return monthExecution;
};

// custom card

export const customCardSection = (cardData = {}) => [
        {
                title: 'Revenue (A)',
                value: cardData.revenue ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,
        },
        {
                title: 'Project Cost-FC Level (B)',
                value: cardData.projectCost ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },

        {
                title: 'DM%',
                value: `${cardData.DM ?? '--'}%`,
                isPositive: true,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },
        {
                title: 'Margin (A-B)',
                value: cardData.profit_loss ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                dmCost: cardData.DM_COST ?? null,
                colorCode: parseFloat(cardData.profit_loss) < 0 ? '#FF0000' : '#079455',
        },
        {
                title: 'Other Apportioned Cost (C)',
                value: cardData.apportionedCost ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },
        
        {
                title: 'Total Cost (B+C)',
                value: (() => {
                        const parseNumber = (val) =>
                                parseFloat((val || '0').toString().replace(/,/g, ''));

                        const formatNumber = (val) =>
                                val.toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                });

                        const projectCost = parseNumber(cardData.projectCost);
                        const apportionedCost = parseNumber(cardData.apportionedCost);
                        const total = projectCost + apportionedCost;

                        return isNaN(total) ? '--' : formatNumber(total);
                })(),
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },
        {
                title: 'Other Operational Income (D)',
                value: cardData.totalOperationalIncome ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },

        {
                title: ' Profit/Loss (A - B - C + D)',
                value: cardData.projectProfit ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                dmCost: cardData.DM_COST ?? null,
                colorCode: parseFloat(cardData.projectProfit) < 0 ? '#FF0000' : '#079455',
        },
        {
                title: 'Net Billing',
                value: cardData.totalNetBilling ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                dmCost: cardData.DM_COST ?? null,

                colorCode: '#000000',
        },
        {
                title: 'Cash Inflow Project Level',
                value: cardData.totalCashInflow ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },
        {
                title: 'Cash Outflow Project Level',
                value: cardData.totalCashOutflow ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
                dmCost: cardData.DM_COST ?? null,

        },
        {
                title: 'Net Cash Flow Project Level',
                value: cardData.netCashFlow ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                dmCost: cardData.DM_COST ?? null,
                colorCode: parseFloat(cardData.netCashFlow) < 0 ? '#FF0000' : '#079455',
        },
];

export const customCardSectionNew = (cardData = {}) => [
        {
                title: 'Revenue (A)',
                value: cardData?.revenue ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },
        {
                title: 'Project Cost (B)',
                value: cardData?.projectCost ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
        },
        {
                title: 'DM%',
                value: `${cardData?.dmPercentage ?? '-'}%`,
                isPositive: true,
        },
        {
                title: 'Profit/Loss (A-B)',
                value: cardData?.profitLoss ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                colorCode: parseFloat(cardData?.profitLoss) < 0 ? '#FF0000' : '#079455',
        },

        {
                title: 'Other Apportioned Cost (C)',
                value: cardData?.aportion ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },
        {
                title: 'Other Operational Income (D)',
                value: cardData?.operational ?? '--',
                isPositive: true,
        },
        {
                title: 'Total Cost (B+C)',
                value: (() => {
                        const parseNumber = (val) =>
                                parseFloat((val || '0').toString().replace(/,/g, ''));

                        const formatNumber = (val) =>
                                val.toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                });

                        const projectCost = parseNumber(cardData.projectCost);
                        const apportionedCost = parseNumber(cardData.aportion);
                        const total = projectCost + apportionedCost;

                        return isNaN(total) ? '--' : formatNumber(total);
                })(),
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },

        {
                title: 'Project Profit (A - B - C + D)',
                value: cardData?.projectProfit ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                colorCode: parseFloat(cardData?.projectProfit) < 0 ? '#FF0000' : '#079455',
        },
        {
                title: 'Net Billing',
                value: cardData?.netBilling ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },

        {
                title: 'Cash Inflow',
                value: cardData?.cashInflow ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },
        {
                title: 'Cash Outflow',
                value: cardData?.cashOutflow ?? '--',
                isPositive: true,
                imageIcon: RupeesIcon,
                colorCode: '#000000',
        },

        {
                title: 'Net Cash Flow',
                value: cardData?.netCashFlow ?? '--',
                isPositive: true,
                imageIcon: NetCashFlow,
                colorCode: parseFloat(cardData?.netCashFlow) < 0 ? '#FF0000' : '#079455',
        },
];